import React from 'react';
import { Link } from 'react-router-dom';
import { useTheme } from '../context/ThemeContext';

const Footer = () => {
  const { isDarkMode } = useTheme();

  const footerSections = {
    developers: {
      title: "Developers",
      links: [
        { name: "Documentation", href: "https://docs.desights.ai/" }
      ]
    },
    // product: {
    //   title: "Product",
    //   links: [
    //     { name: "Competitions", href: "https://docs.desights.ai/products/competitions" },
    //     { name: "Market", href: "https://docs.desights.ai/products/market" },
    //     { name: "Workspaces", href: "https://docs.desights.ai/products/workspaces" },
    //     { name: "Terminal", href: "https://docs.desights.ai/products/terminal" }
    //   ]
    // },
    learn: {
      title: "Learn",
      links: [
        // { name: "Protocol", href: "https://docs.desights.ai/the-protocol/architecture" },
        { name: "Use cases", href: "https://docs.desights.ai/use-cases" },
        { name: "Create profile", href: "https://docs.desights.ai/guides/creating-desights-profile" },
        { name: "Submit to challenge", href: "https://docs.desights.ai/guides/submission-to-the-challenge" }
      ]
    },
    resources: {
      title: "Resources",
      links: [
        { name: "Privacy Policy", href: "https://desights.ai/privacy/" },
        { name: "Terms", href: "https://desights.ai/terms/" }
      ]
    }
  };

  const socialLinks = [
    { 
      name: "Twitter", 
      href: "https://x.com/0xdesights", 
      icon: (
        <svg className="w-6 h-6" viewBox="0 0 24 24">
          <defs>
            <linearGradient id="twitter-gradient" x1="0%" y1="0%" x2="100%" y2="100%">
              <stop offset="0%" stopColor="#FCD535" />
              <stop offset="100%" stopColor="#FF636E" />
            </linearGradient>
          </defs>
          <path 
            d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z"
            fill="url(#twitter-gradient)"
          />
        </svg>
      )
    },
    { 
      name: "Discord", 
      href: "https://discord.com/invite/enZFdaFMpN", 
      icon: (
        <svg className="w-6 h-6" viewBox="0 0 24 24">
          <defs>
            <linearGradient id="discord-gradient" x1="0%" y1="0%" x2="100%" y2="100%">
              <stop offset="0%" stopColor="#FCD535" />
              <stop offset="100%" stopColor="#FF636E" />
            </linearGradient>
          </defs>
          <path 
            d="M20.317 4.37a19.791 19.791 0 0 0-4.885-1.515a.074.074 0 0 0-.079.037c-.21.375-.444.864-.608 1.25a18.27 18.27 0 0 0-5.487 0a12.64 12.64 0 0 0-.617-1.25a.077.077 0 0 0-.079-.037A19.736 19.736 0 0 0 3.677 4.37a.07.07 0 0 0-.032.027C.533 9.046-.32 13.58.099 18.057a.082.082 0 0 0 .031.057a19.9 19.9 0 0 0 5.993 3.03a.078.078 0 0 0 .084-.028a14.09 14.09 0 0 0 1.226-1.994a.076.076 0 0 0-.041-.106a13.107 13.107 0 0 1-1.872-.892a.077.077 0 0 1-.008-.128a10.2 10.2 0 0 0 .372-.292a.074.074 0 0 1 .077-.01c3.928 1.793 8.18 1.793 12.062 0a.074.074 0 0 1 .078.01c.12.098.246.198.373.292a.077.077 0 0 1-.006.127a12.299 12.299 0 0 1-1.873.892a.077.077 0 0 0-.041.107c.36.698.772 1.362 1.225 1.993a.076.076 0 0 0 .084.028a19.839 19.839 0 0 0 6.002-3.03a.077.077 0 0 0 .032-.054c.5-5.177-.838-9.674-3.549-13.66a.061.061 0 0 0-.031-.03zM8.02 15.33c-1.183 0-2.157-1.085-2.157-2.419c0-1.333.956-2.419 2.157-2.419c1.21 0 2.176 1.096 2.157 2.42c0 1.333-.956 2.418-2.157 2.418zm7.975 0c-1.183 0-2.157-1.085-2.157-2.419c0-1.333.955-2.419 2.157-2.419c1.21 0 2.176 1.096 2.157 2.42c0 1.333-.946 2.418-2.157 2.418z"
            fill="url(#discord-gradient)"
          />
        </svg>
      )
    },
    { 
      name: "LinkedIn", 
      href: "https://www.linkedin.com/company/desights/", 
      icon: (
        <svg className="w-6 h-6" viewBox="0 0 24 24">
          <defs>
            <linearGradient id="linkedin-gradient" x1="0%" y1="0%" x2="100%" y2="100%">
              <stop offset="0%" stopColor="#FCD535" />
              <stop offset="100%" stopColor="#FF636E" />
            </linearGradient>
          </defs>
          <path 
            d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z"
            fill="url(#linkedin-gradient)"
          />
        </svg>
      )
    }
  ];

  return (
    <footer className={`${isDarkMode ? 'bg-[#000000]' : 'bg-white'} py-12 font-lexend border-t ${isDarkMode ? 'border-[#1C1C1C]' : 'border-gray-100'}`}>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-2 md:grid-cols-[1fr_1fr_1fr_auto] gap-8">
          {/* Footer Sections */}
          {Object.values(footerSections).map((section) => (
            <div key={section.title}>
              <h3 className={`text-[16px] font-bold mb-4 ${isDarkMode ? 'text-white' : 'text-black'}`}>
                {section.title}
              </h3>
              <ul className="space-y-2">
                {section.links.map((link) => (
                  <li key={link.name}>
                    <Link 
                      to={link.href}
                      className={`text-[14px] ${
                        isDarkMode ? 'text-[#fff]' : 'text-[#000]'
                      } hover:text-[#FCD535] transition-colors duration-200`}
                    >
                      {link.name}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}

          {/* Social Links */}
          <div>
            <h3 className={`text-[16px] font-bold mb-4 ${isDarkMode ? 'text-white' : 'text-black'}`}>
              Follow Us
            </h3>
            <div className="flex space-x-4">
              {socialLinks.map((social) => (
                <a
                  key={social.name}
                  href={social.href}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="hover:opacity-80 transition-opacity duration-200"
                >
                  {social.icon}
                </a>
              ))}
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer; 